"use strict";
exports.__esModule = true;
var Hasher = /** @class */ (function () {
    function Hasher(seed) {
        this.seed = seed;
    }
    Hasher.prototype.hashString = function (stringToHash) {
        var hashValue = stringToHash.split("").reduce(function (previous, current) {
            return previous + current.charCodeAt(0);
        }, 0);
        return Math.floor(hashValue * this.seed * 42) % 100;
    };
    return Hasher;
}());
exports["default"] = Hasher;
